export function blockUi() {
  $("body").css("pointer-events", "none");
  $(".circle").css("display", "block");
}

export function unblockUi() {
  setTimeout(() => {
    $(".circle").css("display", "none");
    Ladda.stopAll();
    $("body").css("pointer-events", "auto");
  }, 1000);
}

